import React, { useEffect, useState, useMemo } from "react";
import { LoadingSpinner } from "../../../Shared";
import { Table, Dropdown, Icon, Label } from "semantic-ui-react";
import { Line } from "@ant-design/charts";
import { Pie, Column,DualAxes } from "@ant-design/plots";
import {
  Permission,
  // AirEmissionsform,
  // Form,
  // Productionform,
} from "../../../../api";
import { useAuth } from "../../../../hooks";
//import "./Dashboard.scss";
import { useLanguage } from "../../../../contexts/LanguageContext";
//import { Renderer as SVGRenderer } from '@antv/g-svg';
import {
  airemissionsKPIsCodes,
  airemissionsFormulasIndicators,
  determineAirEmissionsUnits,
 // airemissionsCodes,
  airemissionsCodes,
  convertAirEmissionsFinal,
} from "../../../../utils/dataAndFormulas/airemissionsForms";
import AirEmissionsSummary from "./AirEmissionsSummary";
import TableGraf from "./TableGraf";
import {
  convertUnits,
  formatValue,
} from "../../../../utils/dataAndFormulas/convert";

const permissionController = new Permission();
// const airEmissionsController = new AirEmissionsform();
// const formController = new Form();
// const productionController = new Productionform();

export function AirEmissionsKPIsDashBoard(props) {
  const { site } = props;
  const {
    user: { role },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);
  const [baseline, setbaseline] = useState("");
  const [valueBaseline, setValueBaseline] = useState({});
  const [indicatorsLineBase, setIndicatorsLineBase] = useState([]);

  const [data, setData] = useState([]);
  const [totales, setTotales] = useState({});
  const [conceptos, setConceptos] = useState([]);

   const [loadingCount, setLoadingCount] = useState(0);
    const isLoading = loadingCount > 0;
    const [lastYears, setLastYears] = useState({}); // resultados calculados
      const [totalesByFilters, setTotalesByFilters] = useState({}); // resultados calculados
    
  
    const startLoading = () => setLoadingCount((prev) => prev + 1);
    const stopLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));
  //declaración estado de filtros
    const [filters, setFilters] = useState({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
    });

  const [configFormData, setConfigFormData] = useState(null);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        airemissionsKPIsCodes.error(error);
        setPermissionsActive([]);
      }finally {
        stopLoading();
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        setData([]);

        if (site) {
          const prueba =
            await airEmissionsController.getAirEmissionsFormsByLineBaseYears(
              accessToken,
              site
            );

          setIndicatorsLineBase(prueba.airEmissionsForms?.indicators || {});
          const yearsLineaBase = prueba.airEmissionsForms.years;
          const currentYear = new Date().getFullYear();

          // Generar los 5 últimos años
          const yearsLast = [
            currentYear,
            currentYear - 1,
            currentYear - 2,
            currentYear - 3,
            currentYear - 4,
          ].map(String);

          // Combina ambos arrays y elimina duplicados utilizando Set
          const yearsCombined = [...new Set([...yearsLineaBase, ...yearsLast])];

          //Busco los datos por los ultimos 5 años mas los años de linea base seleccionados
          const response =
            await airEmissionsController.getAirEmissionsFormsByLastYears(
              accessToken,
              site,
              yearsCombined
            );
          setData(response.airEmissionsForms);
        }
      } catch (error) {
        console.error(error);
        setData([]);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      startLoading();
      setbaseline("");
      try{
      if (site) {
        //Consulto las linea base relacionada a si el año se rige por VPF o VPS
        const response = await formController.getLastBaselineByFormBySite(
          accessToken,
          site,
          "production"
        );

        if (response.code === 200) {
          setbaseline(response.baseline);
          //Para saber el total de los años de baseline sin necesidad de andar consultando varias veces
          const result = await Promise.all(
            Object.entries(response.baseline)
              .filter(([anio, valor]) => valor !== null) // Filtra por los valores no nulos
              .map(async ([anio, valor]) => {
                let a = await getValueBaseLine(anio, valor); // Llamada a la función asincrónica
                return { [anio]: a }; // Devuelve el año y el valor como un objeto
              })
          );

          // Combina todos los objetos en un único objeto final
          const resultadoFinal = result.reduce((acc, obj) => {
            return { ...acc, ...obj }; // Combina los objetos
          }, {});

          setValueBaseline(resultadoFinal);
        }
      }}catch (error) {
        console.error(error);
      } finally {
        stopLoading();
      }
    })();
  }, [site]);

  // Obtener configuración de campos activos del formulario
  useEffect(() => {
    (async () => {
      try {
        if (site) {
          const response = await formController.getFormsBySite(
            accessToken,
            site,
            "airEmissions",
            true,
          );
          if (Array.isArray(response) && response.length > 0) {
            setConfigFormData(response[0]);
          } else {
            setConfigFormData(null);
          }
        }
      } catch (error) {
        console.error("❌ Error al obtener configFormData:", error);
        setConfigFormData(null);
      }
    })();
  }, [site]);

  // Determinar los campos únicos en relacion a los indicadores y si tienen código
  const determineFieldsKPIs = () => {
    const fields = new Set();
    // console.log("🧠 conceptKeys:", conceptos);
    // console.log("🧠 typeof conceptKeys:", typeof conceptos);

    Object.keys(airemissionsKPIsCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  };

  // Determinar los campos únicos del formulario y si tienen código
  const determineFieldsCode = () => {
    const fields = new Set();

    Object.keys(airemissionsCodes).forEach((key) => {
      fields.add(key);
    });

    return Array.from(fields);
  };

  useEffect(() => {
    (async () => {
      startLoading();
      try {
        //Una vez obtenido los datos los proceso para obtener los valores de los campos por cada año
        const previous_totals = await transformData1(data);
        //luego proceso para obtener los valores de los indicadores por cada año
        calculateDataFinal(previous_totals);

         // Año actual
        const currentYear = new Date().getFullYear();

        // 🔹 Últimos 3 años dinámicos
        const lastThreeYears = [currentYear, currentYear - 1, currentYear - 2];

        // 🔹 Filtrar datos solo de esos 3 años
        const filteredByYears = data?.data
          ?.filter((item) => lastThreeYears.includes(Number(item.year))) // 👈 convierte el string
          ?.reduce((acc, item) => {
            const year = Number(item.year);
            if (!acc[year]) acc[year] = [];
            acc[year].push(item);
            return acc;
          }, {});

        // 🔹 Guardar solo años con al menos un mes cargado
        const yearsWithData = lastThreeYears.filter((year) =>
          data?.data?.some((item) => Number(item.year) === year)
        );
        setLastYears(yearsWithData);

        const results = await getLastThreeYearsData(filteredByYears);
        setTotalesByFilters(results);
        
     } catch (error) {
        console.error(error);
      }finally {
        stopLoading();
      }
    })();
  }, [data, valueBaseline]);

  //Calcula el valor de linea base por año hay que cambiar si es por vfs o vps
  const getValueBaseLine = async (year, type) => {
    try {
      if (type === "VPS") {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_production"
          );
        //setValueBaseline(response1.total)
        return response1.total;
      } else {
        const response1 =
          await productionController.getTotalBaselineByYearAndSite(
            accessToken,
            site,
            year,
            "standardized_billing"
          );
        //setValueBaseline(response1.total)
        return response1.total;
      }
    } catch (error) {
      console.error(error);
      return 1; /// Retorna uno por si hay error ver este tema
    }
  };

  //Funcion para obtener los valores de los campos por cada año
  const transformData1 = async (data) => {
    // Inicializar el objeto de totales y los conceptos
    const totalsPerYear = {};
    const conceptsSet = [];
    const unitsCache = {}; // Aquí almacenaremos los datos de unidades por año

    // Unidades configuradas en configFormData tienen prioridad máxima
    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    const fields = determineFieldsCode();

    // Verificar si data y data.data son válidos y contienen datos
    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      //console.log("No hay datos para procesar o data.data no es un array válido");
      return {}; // Retornar un objeto vacío o manejar el caso según se requiera
    }

    // Crear un array de años únicos de los datos de consumo
    const uniqueYears = [
      ...new Set(data.data.map((item) => String(item.year))),
    ];

    // Primero, obtener las unidades para todos los años requeridos
    //console.log('Obteniendo unidades para los años:', uniqueYears);
    const promises = uniqueYears.map(async (año) => {
      try {
        // Realizar la llamada para obtener las unidades para el año
        const units = await airEmissionsController.getLastUnitFieldsByYear(
          accessToken,
          site,
          año,
          fields
        );

        // Guardar en el caché si las unidades son válidas
        if (units && units.fields) {
          unitsCache[año] = units;
          //console.log(`Unidades guardadas en caché para el año ${año}:`, units);
        } else {
          // console.log(`No se obtuvieron unidades válidas para el año ${año}`);
        }
      } catch (error) {
        //console.log(`Error al obtener unidades para el año ${año}:`, error);
      }
    });

    // Esperar a que todas las consultas de unidades se resuelvan
    await Promise.all(promises);

    // Ahora procesamos los datos de consumo usando las unidades en caché
    // console.log('Procesando los consumos');
    if (data.data !== undefined) {
      // Crear un array de promesas para manejar las llamadas asíncronas
      const consumptionPromises = data.data.map(async (item) => {
        const year = String(item.year);

        // Verificar si ya tenemos las unidades para este year en el caché
        const units = unitsCache[year];
        if (!units) {
          //console.log(`No se encontraron unidades para el year ${year} en el caché`);
          return;
        }

        // Iterar sobre los conceptos que tenemos en el item
        fields.forEach((concept) => {
          // Si el concepto existe, procesamos
          if (item[concept]) {
            // Añadir el concepto a la lista de concepts únicos
            conceptsSet.push(concept);

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept]) {
              totalsPerYear[concept] = {};
            }

            // Inicializar el total para el year si no existe
            if (!totalsPerYear[concept][year]) {
              totalsPerYear[concept][year] = {
                total: 0,
                unit: configUnits[concept] || units.fields[concept] || item[concept]?.unit || "",
              };
            }

            // Sumar el valor de consumo
            totalsPerYear[concept][year].total += item[concept].value
              ? convertAirEmissionsFinal(
                  item[concept].value,
                  item[concept].unit,
                  totalsPerYear[concept][year].unit,
                  concept
                )
              : 0;
          }
        });
      });
      // Esperar a que todas las promesas de consumo se resuelvan
      await Promise.all(consumptionPromises);
    }

    return totalsPerYear;
  };

  //Funcion para obtener los valores de los indicadores por cada año
  const calculateDataFinal = async (totales) => {
    // Inicializar el objeto de totales y los conceptos

    const totalsFinal = { ...totales };
    const conceptsSet = [];

    if (totales !== undefined) {
      for (let item in totales) {
        if (totales.hasOwnProperty(item)) {
          for (let year in totales[item]) {
            //const valueB = await getValueBaseLine(year, baseline[year]);
            const valueB = valueBaseline[year];

            if (totales[item].hasOwnProperty(year)) {
              const fields = determineFieldsKPIs();

              // Iterar sobre los conceptos que tenemos en el item
              fields.forEach((concept) => {
                // Añadir el concepto a la lista de conceptos únicos
                // Inicializar el total para el año si no existe
                if (!totalsFinal[concept]) {
                  totalsFinal[concept] = {};
                  conceptsSet.push(concept);
                }

                // Inicializar el total para el año si no existe
                if (!totalsFinal[concept][year]) {
                  totalsFinal[concept][year] = {};
                }

                totalsFinal[concept][year] = airemissionsFormulasIndicators(
                  concept,
                  year,
                  totalsFinal,
                  valueB === 0 ? 1 : valueB
                );
              });
            }
          }
        }
      }
    }

    setConceptos(conceptsSet);
    setTotales(totalsFinal);
  };
// Función para obtener los valores de un año y mes específicos (period en texto)
  const getDataByYearAndMonth = async (data, year, month) => {
    const results = {};
    const fields = determineFieldsCode();
    const unitsCache = {};

    const configUnits = {};
    if (configFormData?.fields && configFormData.fields.length > 0) {
      configFormData.fields.forEach((field) => {
        if (field.name && field.unit) {
          configUnits[field.name] = field.unit;
        }
      });
    }

    if (!data || !data || Object.keys(data).length === 0) {
      return {};
    }

    // Diccionario de meses
    const monthMap = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };

    const yearStr = String(year);
    const monthStr =
      typeof month === "string"
        ? monthMap[month] || ""
        : String(month).padStart(2, "0");

    if (!monthStr) {
      console.warn("Mes inválido o no reconocido:", month);
      return {};
    }

    const yearData = data[yearStr];
    if (!Array.isArray(yearData)) {
      console.warn("No hay datos para el año:", yearStr);
      return {};
    }

    const filteredData = yearData.filter(
      (item) => monthMap[item.period] === monthStr
    );

    if (filteredData.length === 0) {
      console.warn(`No hay datos para ${month} ${yearStr}`);
      return {};
    }

    // Procesar resultados por campo
    filteredData.forEach((item) => {
      const units = unitsCache[yearStr];

      fields.forEach((concept) => {
        if (item[concept]) {
          if (!results[concept]) {
            results[concept] = {
              total: 0,
              unit: configUnits[concept] || units?.fields[concept] || item[concept]?.unit || "",
            };
          }

          results[concept].total += item[concept].value
            ? convertUnitsFinal(
                item[concept].value,
                item[concept].unit,
                results[concept].unit,
                concept
              )
            : 0;
        }
      });
    });

    // ==========================
    // 🔹 Calcular energía total (sin incluir costos)
    // ==========================

    // Lista de conceptos energéticos (sin costos)
    const energyConcepts = Object.keys(energyCodes).filter(
      (key) => !key.includes("cost")
    );

    let totalEnergyMonth = 0;
    let energyUnit = "";

    energyConcepts.forEach((concept) => {
      if (results[concept] && typeof results[concept].total === "number") {
        totalEnergyMonth += results[concept].total;
        energyUnit = results[concept].unit || energyUnit;
      }
    });

    results.total_energy_month = {
      total: totalEnergyMonth,
      unit: energyUnit || "MWh",
    };


        // ==========================
    // 🔹 Calcular renovables
    // ==========================

        // ==========================
    // 🔹 Calcular electrica
    // ==========================
    return results;
  };

  // ==========================
  // 🔹 Calcular ultimos 3 años
  // ==========================

  const getLastThreeYearsData = async (totalesByFilters) => {
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear - 2, currentYear - 1, currentYear];

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const resultsByYear = {};

    for (const year of lastThreeYears) {
      resultsByYear[year] = {};

      for (const month of months) {
        const data = await getDataByYearAndMonth(totalesByFilters, year, month);
        resultsByYear[year][month] = data;
      }
    }

    return resultsByYear;
  };

  const removeNulls = (data, concepts) => {
    // Iterar sobre las claves externas
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        // Verificar si todos los valores internos son 0
        const allZero = Object.values(data[key]).every(
          (value) =>
            value.total === 0 || value.total === undefined || isNaN(value.total)
        );

        // Si todos los valores son 0, eliminar la clave externa
        if (allZero) {
          //delete concepts[key];
          concepts = concepts.filter((item) => item !== key);
        }
      }
    }
    return concepts;
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (
    !data ||
    !data.years ||
    data.years.length === 0 ||
    !conceptos ||
    conceptos.length === 0
  ) {
    return (
      <div style={{ textAlign: "center", padding: "5em 0", color: "#777" }}>
        <div style={{ fontSize: "2em", marginBottom: "1em", color: "#ccc" }}>
          <Icon name="exclamation triangle" size="huge" color="gray" />
        </div>
        <div
          style={{ fontSize: "1.5em", fontWeight: "bold", marginBottom: "1em" }}
        >
          {t("no_data_available") || "No hay datos disponibles"}
        </div>
      </div>
    );
  } else {
    return (
      <div className="list-energy-forms">
        {/* Aquí pasamos los datos ya calculados */}
        <AirEmissionsSummary
          filters={filters}
          site={site}
          valueBaseline={valueBaseline}
          energyController={AirEmissionsform}
          totales={totalesByFilters} // ✅ nuevo prop
          //totalesByFilters={totalesByFilters}
          selectorSlot={<YearMonthSelector onChange={setFilters} />}
        />
        <TableGraf filters={filters} totales={totales} />
        <AirEmissionsComparisonChart resultsByYear={totalesByFilters} />
        <AirEmissionsMonthlyChart resultsByYear={totalesByFilters}/>
        {/* //<EnergyChart filters={filters} data={data} /> */}
        {/*} <EnergyIntensityChart  totales={totales} />*/}
        <TableYears
          filters={filters}
          data={data}
          accessToken={accessToken}
          t={t}
          conceptos={conceptos}
          totales={totales}
          language={language}
          indicatorsLineBase={indicatorsLineBase}
          valueBaseline={valueBaseline}
        />
      </div>
    );
  }
}

function TableYears(props) {
  const {
    data,
    conceptos,
    totales,
    t,
    language,
    valueBaseline,
    indicatorsLineBase,
    filters,
  } = props;

  const { year, month } = filters || {};
  const [years, setYears] = useState([]);
  const [months, setMoths] = useState([]);
  const [listConceptos, setListConceptos] = useState([]);

  //const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);

  const handleUnitChange = (rowIndex, newValue) => {
    setSelectedUnits({ ...selectedUnits, [rowIndex]: newValue.value });
  };

  useEffect(() => {
    console.log("📊 TableGraf filtrando con:", { year, month });
  }, [year, month]);

  useEffect(() => {
    (async () => {
      try {
        setYears(data.years ? data.years.sort((a, b) => b - a) : []);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [data]);

  useEffect(() => {
    (async () => {
      try {
        // Obtener todos los campos únicos
        let valor = {};
        conceptos.map(
          (field) => (valor[field] = determineEnergyUnits(field)[0].value)
        );
        setSelectedUnits(valor);
      } catch (error) {
        //console.error(error);
        setSelectedUnits([]);
      }
    })();
  }, [conceptos]);

  useEffect(() => {
    (async () => {
      try {
        setListConceptos(conceptos);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [conceptos]);

  // Función para obtener el icono de aumento o disminución
  const getComparativeIcon = (currentYear, previousYear) => {
    if (previousYear !== null) {
      if (currentYear > previousYear) {
        return <Icon disabled name="angle up" color="green" />; // Aumento
      } else if (currentYear < previousYear) {
        return <Icon disabled name="angle down" color="red" />; // Disminución
      } else if (currentYear === previousYear) {
        return <span style={{ color: "blue", fontWeight: "bold" }}>=</span>;
      }
    }
    return null; // Sin cambio
  };

  // Función para obtener el icono de aumento o disminución
  const getIndicators = (item) => {
    let result = indicatorsLineBase.find((value) => value.name === item);
    if (result) {
      return result?.yearBaseline || 0;
    }
    return 0; // Sin cambio
  };

  function showWithTwoDecimals(numero) {
    // Verificamos si el parámetro es un número
    if (typeof numero !== "number" || isNaN(numero)) {
      // Si el valor no es un número, simplemente retornamos el valor tal como está.
      return numero;
    }

    // Si el número es entero, lo mostramos como entero.
    if (numero % 1 === 0) {
      return numero.toString(); // Muestra el número como cadena sin decimales.
    } else {
      // Si el número tiene decimales, lo mostramos con hasta 4 decimales
      // Usamos toFixed(2) para asegurar que no haya más de 4 decimales, pero luego
      // eliminamos los ceros innecesarios.
      let numeroConCuatroDecimales = numero.toFixed(2);

      // Eliminamos los ceros a la derecha si los hay
      return parseFloat(numeroConCuatroDecimales).toString();
    }
  }

  return (
    <>
      <Table celled structured size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("indicators")}
            </Table.HeaderCell>
            {years.map((year, index) => (
              <Table.HeaderCell rowSpan="2" textAlign="center" key={index}>
                {year}
              </Table.HeaderCell>
            ))}
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("LB")}
            </Table.HeaderCell>
            <Table.HeaderCell
              rowSpan="2"
              textAlign="center"
              style={{ width: "200px" }}
            >
              {t("units")}
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="center">
              {t("MWh equivalentes")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {conceptos.map((item, index) => (
            <React.Fragment key={index}>
              <Table.Row>
                <Table.Cell>{airemissionsKPIsCodes[item]}</Table.Cell>
                <Table.Cell>{t(item)}</Table.Cell>
                {years.map((year, i) => {
                  if (totales[item]) {
                    const currentValue = totales[item][year]?.total || 0;
                    const previousValue = totales[item][year - 1]?.total
                      ? totales[item][year - 1]?.total
                      : 0; // Compara con el año anterior
                    return (
                      <Table.Cell key={i}>
                        {formatValue(
                          showWithTwoDecimals(
                            convertUnits(
                              totales[item][year]?.total || 0,
                              totales[item][year]?.unit,
                              selectedUnits[item],
                              selectedUnits
                            )
                          ),
                          language
                        )}{" "}
                        {i >= 0 &&
                          getComparativeIcon(currentValue, previousValue)}
                      </Table.Cell>
                    );
                  }
                  return <Table.Cell key={i}>{""}</Table.Cell>;
                })}
                <Table.Cell>
                  {showWithTwoDecimals(
                    totales[item][getIndicators(item)]?.total
                  ) || 0}
                </Table.Cell>
                <Table.Cell>
                  {
                    <Dropdown
                      onChange={(e, data) => {
                        handleUnitChange(item, data);
                      }}
                      options={determineAirEmissionsUnits(item).map((ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      })}
                      search
                      inline
                      defaultValue={determineAirEmissionsUnits(item)[0].value}
                      //value={filter}
                    />
                  }
                </Table.Cell>

                <Table.Cell>
                  {/* {" "}
                  {convertUnitsFinal(
                    totales[item][getIndicators(item)]?.total || 0,
                    totales[item][getIndicators(item)]?.unit,
                    "MWh",
                    item
                  ) || 0} */}
                </Table.Cell>
              </Table.Row>
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}

export const YearMonthSelector = ({ onChange }) => {
  const currentYear = new Date().getFullYear();

  const years = [
    { key: currentYear, text: currentYear, value: currentYear },
    { key: currentYear - 1, text: currentYear - 1, value: currentYear - 1 },
    { key: currentYear - 2, text: currentYear - 2, value: currentYear - 2 },
    { key: currentYear - 3, text: currentYear - 3, value: currentYear - 3 },
  ];

  const months = [
    { key: 1, text: "Enero", value: 1 },
    { key: 2, text: "Febrero", value: 2 },
    { key: 3, text: "Marzo", value: 3 },
    { key: 4, text: "Abril", value: 4 },
    { key: 5, text: "Mayo", value: 5 },
    { key: 6, text: "Junio", value: 6 },
    { key: 7, text: "Julio", value: 7 },
    { key: 8, text: "Agosto", value: 8 },
    { key: 9, text: "Septiembre", value: 9 },
    { key: 10, text: "Octubre", value: 10 },
    { key: 11, text: "Noviembre", value: 11 },
    { key: 12, text: "Diciembre", value: 12 },
  ];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // 1-12

  const handleYearChange = (e, { value }) => {
    setSelectedYear(value);
    onChange({ year: value, month: selectedMonth });
  };



  return (
    <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
      <Dropdown
        placeholder="Año"
        selection
        options={years}
        value={selectedYear}
        onChange={handleYearChange}
      />

    </div>
  );
};

function AirEmissionsComparisonChart({ resultsByYear }) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthMap = {
    January: "Enero",
    February: "Febrero",
    March: "Marzo",
    April: "Abril",
    May: "Mayo",
    June: "Junio",
    July: "Julio",
    August: "Agosto",
    September: "Septiembre",
    October: "Octubre",
    November: "Noviembre",
    December: "Diciembre",
  };

  const years = Object.keys(resultsByYear);

  // // Datos de barras
  // const barData = [];
  // years.forEach((year) => {
  //   months.forEach((month) => {
  //     const total =
  //       resultsByYear?.[year]?.[month]?.total_energy_month?.total || 0;
  //     barData.push({
  //       year: String(year),
  //       month, // ⚠ mantener en inglés para agrupar correctamente
  //       value: total,
  //     });
  //   });
  // });

  // // Datos de línea de promedio por año
  // const lineData = [];
  // years.forEach((year) => {
  //   const values = months.map(
  //     (month) => resultsByYear?.[year]?.[month]?.total_energy_month?.total || 0
  //   );
  //   const avg = values.reduce((a, b) => a + b, 0) / values.length;
  //   months.forEach((month) => {
  //     lineData.push({
  //       year: String(year),
  //       month,
  //       value: avg,
  //     });
  //   });
  // });

    // ✅ Calcular los datos solo cuando cambien resultsByYear
  const { barData, lineData } = useMemo(() => {
    const bar = [];
    const line = [];

    years.forEach((year) => {
      const values = months.map(
        (month) => resultsByYear?.[year]?.[month]?.total_airEmissions_month?.total || 0
      );

      const avg = values.reduce((a, b) => a + b, 0) / values.length;

      months.forEach((month, i) => {
        const total = values[i];
        bar.push({
          year: String(year),
          month,
          value: total,
        });
        line.push({
          year: String(year),
          month,
          value: avg,
        });
      });
    });

    return { barData: bar, lineData: line };
  }, [resultsByYear]); // 👈 solo recalcula si cambian los datos

  const config = {
    xField: "month",
    legend: true,
    children: [
      {
        data: barData,
        type: "interval",
        // xField: "month",
        yField: "value",
        colorField: "year",
        seriesField: "year", // 🔹 esto separa las barras por año
        group: true,
        // style: { maxWidth: 80 },
        interaction: { elementHighlight: { background: true } },
      },
      {
        data: lineData,
        type: "line",
        yField: "value",
        // xField: "month",
        colorField: "year",
        smooth: true,
        lineStyle: { lineWidth: 2, lineDash: [4, 4] },
        axis: { y: { position: "right" } },
      },
    ],
    tooltip: { shared: true },
    height: 300,
    legend: { position: "top" },
    xAxis: {
      label: {
        formatter: (val) => t(val) || val, // 🔹 mostrar meses en español
      },
    },
  };

  return (
    <div style={{ height: 350, marginTop: 20, marginBottom: 20 }}>
      <h3 className="text-lg font-semibold mb-2 text-center">
        🔋 Consumo energético comparativo — Últimos 3 años
      </h3>
      <DualAxes {...config} />
    </div>
  );
}

function AirEmissionsMonthlyChart({ resultsByYear }) {

  console.log(resultsByYear)
  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const monthMap = {
    January: "Enero", February: "Febrero", March: "Marzo", April: "Abril",
    May: "Mayo", June: "Junio", July: "Julio", August: "Agosto",
    September: "Septiembre", October: "Octubre",
    November: "Noviembre", December: "Diciembre",
  };

  const years = Object.keys(resultsByYear);

  // 🔹 Paleta de colores fija por año
  const yearColors = {
    2023: '#5B8FF9', // azul
    2024: '#34D399', // verde
    2025: '#F6BD16', // amarillo
    2026: '#EF4444', // rojo
  };

    // ✅ useMemo garantiza nueva referencia cuando cambia resultsByYear
  const { consumptionData, averageData } = useMemo(() => {
    const cData = [];
    const aData = [];

    years.forEach((year) => {
      const totals = months.map(
        (m) => resultsByYear?.[year]?.[m]?.total_energy_month?.total || 0
      );
      const avg = totals.reduce((a, b) => a + b, 0) / totals.length;

      months.forEach((month, i) => {
        const total = totals[i];
        cData.push({
          year,
          month: monthMap[month],
          value: total,
          type: 'Consumo',
        });
        aData.push({
          year,
          month: monthMap[month],
          value: avg,
          type: 'Promedio',
        });
      });
    });

    return { consumptionData: cData, averageData: aData };
  }, [resultsByYear]); // 👈 se recalcula solo cuando cambian los datos

  // 🔹 Config del gráfico
  const config = {
    xField: 'month',
        scale: {
      color: {
        // 👇 Colores por año (en orden)
        range: ['#5B8FF9', '#5AD8A6', '#5D7092', '#F6BD16', '#6F5EF9'],
      },
    },
    children: [
      // Línea sólida (consumo)
      {
        data: consumptionData,
        type: 'line',
        yField: 'value',
        colorField: 'year',
        shapeField: 'smooth',
        style: ({ year }) => ({
          lineWidth: 3,
          stroke: yearColors[year] || '#999999',
        }),
      },
      // Línea punteada (average)
      {
        data: averageData,
        type: 'line',
        yField: 'value',
        colorField: 'year',
        shapeField: 'smooth',
        style: ({ year }) => ({
          lineWidth: 2,
          lineDash: [6, 4],
          stroke: yearColors[year] || '#999999',
        }),
      },
    ],
    xAxis: {
      label: { formatter: (val) => monthMap[val] || val },
    },
    legend: {
      position: 'top',
      itemName: {
        formatter: (text, item) => `Año ${item.value}`,
      },
    },
    tooltip: { shared: true },
    height: 400,
  };

  return (
    <div style={{ height: 450, marginTop: 20, marginBottom: 20 }}>
      <h3 className="text-lg font-semibold mb-2 text-center">
        ⚡ Consumo mensual de Energía Eléctrica / Producción
      </h3>
      <DualAxes {...config} />
    </div>
  );
}


